import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Alarm/Actions/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/AlarmPerm';
import SettingsTable from 'components/Web_User_Interface/1440p_Series/Alarm/Actions/settingsTable';
import ActionsTable from 'components/Web_User_Interface/1440p_Series/Alarm/Actions/actionsTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  PermissionBox,
  SettingsTable,
  ActionsTable,
  BreadCrumbs,
  SEOHelmet,
  React
};